/**
 * NewsItemView view component.
 * @module components/theme/View/NewsItemView
 */

import React from 'react';
import PropTypes, { func } from 'prop-types';
import RenderBlocks from '@plone/volto/components/theme/View/RenderBlocks';

import { Image } from 'semantic-ui-react';
import { hasBlocksData, flattenHTMLToAppURL } from '@plone/volto/helpers';
import FadeInSection from "../../theme/Animations/FadeInSection"
import { flattenToAppURL } from '@plone/volto/helpers';

/**
 * NewsItemView view component class.
 * @function NewsItemView
 * @params {object} content Content object.
 * @returns {string} Markup of the component.
 */
const NewsItemView = (props) => {
  const { content } = props;

  const leftDesignElem = (
    <div className='leftDesign'>
      <svg width="620" xmlns="http://www.w3.org/2000/svg" height="15" fill="none">
        <path d="M0 7.5H600" className="fills" />
        <g className="strokes">
          <path
            d="M0 7.5H600"
            style={{
              fill: 'none',
              strokeWidth: 5,
              stroke: 'rgb(255, 255, 255)',
              strokeOpacity: 1,
              strokeDasharray: '0, 10',
              strokeLinecap: 'round',
            }}
            className="stroke-shape"
          />
        </g>
        <path
          d="M607.071 0c4.14 0 7.5 3.361 7.5 7.5 0 4.139-3.36 7.5-7.5 7.5a7.504 7.504 0 0 1-7.5-7.5c0-4.139 3.361-7.5 7.5-7.5Zm0 3a4.502 4.502 0 0 0-4.5 4.5c0 2.484 2.017 4.5 4.5 4.5 2.484 0 4.5-2.016 4.5-4.5s-2.016-4.5-4.5-4.5Z"
          style={{
            fill: 'rgb(255, 255, 255)',
            fillOpacity: 1,
          }}
          className="fills"
        />
        <g className="strokes">
          <path
            d="M607.071 0c4.14 0 7.5 3.361 7.5 7.5 0 4.139-3.36 7.5-7.5 7.5a7.504 7.504 0 0 1-7.5-7.5c0-4.139 3.361-7.5 7.5-7.5Zm0 3a4.502 4.502 0 0 0-4.5 4.5c0 2.484 2.017 4.5 4.5 4.5 2.484 0 4.5-2.016 4.5-4.5s-2.016-4.5-4.5-4.5Z"
            style={{
              fill: 'none',
              strokeWidth: 1,
              stroke: 'rgb(255, 255, 255)',
              strokeOpacity: 1,
            }}
            className="stroke-shape"
          />
        </g>
      </svg>
    </div>
  );

  const removeTitle = (props) => {
    if(!props.content || !props.content.blocks) return props;

    const blocks = props.content.blocks;
    const newBlocks = {}
    const removedTitles = []

    Object.keys(blocks).map((key, index) => {
      if (blocks[key]['@type'] !== 'title') {
        newBlocks[key] = blocks[key];
      } else {
        removedTitles.push(key);
      }
    });

    function isInArray(value) {
      return !removedTitles.includes(value);
    }

    const newprops = { ...props, content: { ...props.content, blocks: newBlocks, blocks_layout: {"items": props.content.blocks_layout.items.filter(isInArray)} } }
    return newprops;
  }

  console.log(removeTitle(props));
  return (
    <div id="page-document" className="newsitem-view">
      <div className="full-width highlight-title">
        <h1 className="documentFirstHeading">
          {content.title}
          {leftDesignElem}
        </h1>
      </div>
      {content && (
        <FadeInSection>
          {content.image && <Image src={flattenToAppURL(content.image.download)} className='news-teaser-img' />}
        </FadeInSection>
      )}
      {hasBlocksData(content) &&
        <>
          <RenderBlocks {...removeTitle(props)} />
        </>
      }
    </div>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
NewsItemView.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    text: PropTypes.shape({
      data: PropTypes.string,
    }),
  }).isRequired,
};

export default NewsItemView;
